import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { GetAccountDetailsUrl, GetAccountUpdateUrl, GetPendingAccountManagementUpdatesUrl } from '../constants';
import { GenericErrorResponseCode } from '@tradingblock/types';
import { DateFormats, GetMiscellaneousDocumentsMetadataUrl, GetMiscellaneousDocumentsUrl, UploadMiscellaneousDocumentsUrl } from '..';
import dayjs from 'dayjs';
import { RequestHeaders } from './utilities';
export function GetAccountDetails(api) {
  return function (details) {
    return api.get(GetAccountDetailsUrl, {
      details: details
    });
  };
}
export function GetAccountUpdate(api) {
  return function (update) {
    return api.get(GetAccountUpdateUrl, {
      update: update
    });
  };
}

var blobToBase64 = function blobToBase64(blob) {
  return new Promise(function (resolve, _) {
    var reader = new FileReader();

    reader.onloadend = function () {
      return resolve(reader.result);
    };

    reader.readAsDataURL(blob);
  });
};

export var AccManagement = function AccManagement(api) {
  return {
    details: GetAccountDetails(api),
    getUpdate: GetAccountUpdate(api),
    uploadMiscellaneousDocument: function uploadMiscellaneousDocument(file, accountId, documentType, description) {
      var TakenOn = dayjs(file.lastModified).utc().format(DateFormats.DateTimeApiFormat);
      var data = new FormData();
      data.append('metaData', JSON.stringify({
        DocumentName: documentType,
        ImageName: file.name,
        TakenOn: TakenOn,
        Description: description
      }));
      data.append('file', file);
      return api.authenticated().post(UploadMiscellaneousDocumentsUrl(accountId), data);
    },
    getMiscellaneousDocument: function getMiscellaneousDocument(accountId, documentId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var url, result, base64, imageBase64;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = GetMiscellaneousDocumentsUrl(accountId, documentId);
                _context.prev = 1;
                _context.next = 4;
                return api.authenticated().getBinary(url, {});

              case 4:
                result = _context.sent;

                if (!(result.status === 200)) {
                  _context.next = 9;
                  break;
                }

                base64 = Buffer.from(result.data, 'binary').toString('base64');
                imageBase64 = "data:".concat(result.headers['content-type'], ";base64,").concat(base64);
                return _context.abrupt("return", imageBase64);

              case 9:
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                console.warn('error requesting miscellaneous document', accountId);
                return _context.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: _context.t0
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));
    },
    getMiscellaneousDocumentMetadata: function getMiscellaneousDocumentMetadata(accountId, documentId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var url, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = GetMiscellaneousDocumentsMetadataUrl(accountId, documentId);
                _context2.prev = 1;
                _context2.next = 4;
                return api.authenticated().get(url, {
                  accountId: accountId,
                  documentId: documentId
                });

              case 4:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.warn('error requesting miscellaneous document', accountId);
                return _context2.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: _context2.t0
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));
    },
    firmApproveDocument: function firmApproveDocument(accountId, documentId, note) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var url;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = "Accounts/FirmApproveMiscellaneousDocument?accountId=".concat(accountId, "&documentId=").concat(documentId);
                _context3.next = 3;
                return api.authenticated().put(url, note);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    firmRejectDocument: function firmRejectDocument(accountId, documentId, note) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var url;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = "Accounts/RejectMiscellaneousDocument?accountId=".concat(accountId, "&documentId=").concat(documentId);
                _context4.next = 3;
                return api.authenticated().put(url, note);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    getPendingUpdates: function getPendingUpdates(accountId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api.get(GetPendingAccountManagementUpdatesUrl, {
                  accountId: accountId
                }, RequestHeaders);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  };
};